import React from "react";
import { createRoot } from "react-dom/client";

import App from "./app";
import { GlobalStyles } from "./index.style";

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <GlobalStyles />
    <App />
  </React.StrictMode>
);

//connection